import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useState } from "react";
import styles from "../../pages/Post/Post.module.scss";

const CustomCalendar = ({ isOpen, setIsOpen, setTimer, setSelectedDate }) => {
    // const [selectedDate, setSelectedDate] = useState(new Date());
    const [localDate, setLocalDate] = useState(new Date());

    if (!isOpen) return null;

    return (
        <div className={styles["calendar-overlay"]}>
            <div className={styles["calendar-modal"]}>

                <h3>Select date</h3>

                <DatePicker
                    inline
                    selected={localDate}
                    onChange={(date) => {
                        setLocalDate(date);       
                        setSelectedDate(date);

                        const today = new Date();
                        const diffTime = date - today;
                        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                        setTimer(diffDays.toString());
                    }}
                    minDate={new Date()}
                />

                <div className={styles["calendar-actions"]}>
                    <button onClick={() => setIsOpen(false)}>Cancel</button>
                    <button onClick={() => setIsOpen(false)}>OK</button>
                </div>

            </div>
        </div>
    );
};


export default CustomCalendar;


